/** Index / row-number column share of table width. */
export const ROW_NUMBER_WIDTH_PCT = 3;

/** Filing-report style table shell. */
export const TABLE_PAPER_SX = {
  display: "flex",
  flexDirection: "column" as const,
  overflow: "hidden",
  borderColor: "rgba(15, 23, 42, 0.12)",
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
};

export const TABLE_TOOLBAR_SX = {
  px: 2,
  py: 1.25,
  bgcolor: "grey.50",
};

/** Light professional header — matches ThemeManager table treatment. */
export const TABLE_HEADER_CELL_SX = {
  fontWeight: 600,
  fontSize: "0.75rem",
  letterSpacing: "0.04em",
  textTransform: "uppercase" as const,
  backgroundColor: "#f6f7fb",
  color: "text.secondary",
  borderBottom: "1px solid",
  borderColor: "divider",
  whiteSpace: "nowrap" as const,
  py: 1.5,
  px: 1.25,
  lineHeight: 1.3,
  overflow: "hidden",
  textOverflow: "ellipsis",
  "& .MuiTableSortLabel-root": {
    color: "text.secondary",
    "&:hover": { color: "text.primary" },
    "&.Mui-active": { color: "text.primary" },
  },
  "& .MuiTableSortLabel-icon": {
    color: "text.secondary !important",
  },
};

export const TABLE_BODY_CELL_SX = {
  fontSize: "0.8125rem",
  py: 1.35,
  px: 1.25,
  lineHeight: 1.4,
  borderColor: "divider",
  verticalAlign: "top" as const,
  overflow: "hidden",
  wordBreak: "break-word" as const,
  color: "text.primary",
};

export const TABLE_ROW_HOVER_SX = {
  "&.MuiTableRow-hover:hover": {
    bgcolor: "#fafbfd",
  },
  "&:hover > .MuiTableCell-body": {
    backgroundColor: "#fafbfd",
  },
};

export const TABLE_PAGINATION_SX = {
  flexShrink: 0,
  minHeight: 52,
  bgcolor: "grey.50",
  borderTop: "1px solid",
  borderColor: "divider",
  ".MuiTablePagination-toolbar": { px: 2 },
  ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
    fontSize: "0.8125rem",
  },
};

/** Standard rows-per-page options across report tables. */
export const TABLE_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;

export const ROW_NUMBER_BADGE_SX = {
  width: 26,
  height: 26,
  borderRadius: "6px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: "rgba(27, 30, 51, 0.06)",
  fontSize: "0.75rem",
  fontWeight: 700,
  color: "text.secondary",
};

/** Full-height report page shell. */
export const REPORT_PAGE_SX = {
  height: "var(--app-content-height)",
  display: "flex",
  flexDirection: "column" as const,
  gap: 1,
  overflow: "hidden",
};
